import { css } from "@emotion/core";

export const title = css`
  text-align: center;
  font-weight: bold;
`;
